var site = site || {};

site.customerServiceContact_v2 = site.customerServiceContact_v2 || (function ($) {
  var $contactForm;

  function bindEvents() {
    // When a menu link is clicked, toggle its submenu.
    $('.customer-service-menu .menu__link--lvl-1').on('click', toggleSubmenu);
  }

  // When a menu topic is clicked, reveal (or hide) the submenu.
  function toggleSubmenu() {
    $(this).parent().toggleClass('active-submenu');
  }

  return {
    init: function () {
      bindEvents();
    }
  };
})(jQuery);

(function ($) {
  Drupal.behaviors.customerServiceContactV2 = {
    attach: function (context, settings) {
      site.customerServiceContact_v2.init();
    }
  };
})(jQuery);
